// extracted by mini-css-extract-plugin
module.exports = {"details":"OverheadTypeDetails_details__2Ky7o"};